const initVideo = () => {
    const video = document.querySelector("[data-video]");
    if (video) {
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://player.vimeo.com/api/player.js`;
        document.head.appendChild(script);
    }
};
